import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Auth } from 'aws-amplify';
import { take } from 'rxjs/operators';

import { UserService } from '../../../core/api/user.service';
import { passwordMatchValidator, passwordPolicyValidator } from '../../../shared/lib/validators';
import { User } from '../../../shared/models';
import { ToastLevel } from '../../../shared/models/toast-message.module';
import { BackService } from '../../../shared/services/back.service';
import { ToastService } from '../../../shared/services/toast.service';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import * as fromApp from '../../../store';
import { selectCurrentUser } from '../../../store/auth/auth.selectors';
import { AbstractAuthComponent } from '../abstract-auth.component';

@Component({
  selector: 'fc-auth-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['../auth.component.scss'],
})
export class ChangePasswordComponent extends AbstractAuthComponent implements OnInit {
  currentUser?: User;
  changePasswordForm: FormGroup = this.formBuilder.group(
    {
      currentPassword: new FormControl(null, [Validators.required, passwordPolicyValidator]),
      newPassword: new FormControl(null, [Validators.required, passwordPolicyValidator]),
      verifyPassword: new FormControl(null, [Validators.required, passwordPolicyValidator]),
    },
    { validators: [passwordMatchValidator] }
  );
  showCurrentPassword: boolean = false;
  showNewPassword: boolean = false;
  showVerifyPassword: boolean = false;

  constructor(
    readonly route: ActivatedRoute,
    readonly spinnerService: SpinnerService,
    readonly store: Store<fromApp.AppState>,
    readonly userService: UserService,
    private formBuilder: FormBuilder,
    readonly router: Router,
    readonly toastService: ToastService,
    private backService: BackService
  ) {
    super();
  }

  ngOnInit(): void {
    this.store
      .select(selectCurrentUser)
      .pipe(take(1))
      .subscribe({
        next: (currentUser: User | null) => {
          if (currentUser) {
            this.currentUser = currentUser;
          }
        },
        error: (error: any) => {
          throw error;
        },
      });
  }

  goBack() {
    this.backService.goBack();
  }

  redirect(): void {
    if (this.currentUser.isLandowner) {
      this.router.navigate(['/account/dashboard']);
    } else {
      this.router.navigate(['/admin/dashboard']);
    }
  }

  changePassword(): void {
    this.spinnerService.show('auth-spinner');
    Auth.currentAuthenticatedUser()
      .then((cognitoResponse: any) => {
        this.cognitoUser = cognitoResponse;
        Auth.changePassword(
            this.cognitoUser,
            this.changePasswordForm.value.currentPassword,
            this.changePasswordForm.value.newPassword
          )
          .then((_success: string) => {
            if (this.currentUser) {
              this.toastService.sendMessage('Password change successful', ToastLevel.SUCCESS, 5000);
              this.userService.sendPasswordChangeEmail().subscribe((_response: string) => this.redirect());
            }
          })
          .catch(err => {
            this.errorMessage = err.message;
          });
      })
      .catch(_err => {
        this.errorMessage = 'Could not get user information';
      })
      .finally(() => {
        this.spinnerService.hide('auth-spinner');
      });
  }
}
